import type { RiskRecognitionHighlight } from '@cobliteam/api-lib/src/dashboard/riskRecognitions/Types';

// `surface` distingue onde o alerta foi mostrado/acionado: card flutuante (/monitoring) vs toast (qualquer
// página). As duas surfaces emitem os mesmos eventos Displayed/Dismissed/Action Clicked, então o prop é o
// que deixa o analytics separá-las. Omitido quando não passado (ex.: eventos do drawer, surface única).
export type RiskRecognitionSurface = 'card' | 'toast';

// Nomes de evento do risco — mantidos EXATAMENTE como hoje (dashboards/funis dependem deles). Tipos novos
// declaram os seus próprios. Os eventos extras do drawer (View Route / Investigate / Talk To Driver) ficam
// inline no RiskDrawer, surface única.
export const RISK_RECOGNITION_EVENTS = {
  displayed: 'AI - Risk Recognition - Displayed',
  dismissed: 'AI - Risk Recognition - Dismissed',
  action: 'AI - Risk Recognition - Action Clicked',
  drawerClosed: 'AI - Risk Recognition - Drawer Closed',
} as const;

export const buildRiskRecognitionEventProps = (highlight: RiskRecognitionHighlight | null | undefined, surface?: RiskRecognitionSurface) => {
  const metadata = highlight?.metadata;
  return {
    rule_name: metadata?.rule_name,
    criticality_score: metadata?.criticality_score,
    device_id: metadata?.device_id,
    vehicle_plate: metadata?.vehicle_plate,
    driver_id: metadata?.driver_id,
    time_bucket_begin: highlight?.time_bucket_begin,
    ...(surface ? { surface } : {}),
  };
};
